import React from "react";

function Prettiersun() {
  return (
    <div class="row">
      <div class="col-md-12 margin_60 description">
        <h2 class="margin_30">Développement web e-commerce - prettiersun .</h2>
        <div class="row">
          <div class="col-md-7 description">
            <p>
              {/* - Développement du site e-commerce prettiersun.com et d'un site
              d'administration interne : Front-end réalisé en Node.Js
              (Express.Js / EJS) et utilisation de l'ODM MongoDB
              <br />- Utilisation API Stripe / Paypal / Google auth */}
              <small>oct. 2022 - déc. 2023 · 1 an 3 mois</small>
              <br />
              <br />
              Réalisation du site e-commerce prettiersun.com.
              <br />
              <br />
              ℹ️ Front-end réalisé en EJS et Backend en NodeJs avec Express,
              ainsi qu'une API Rest et utilisation de l'ODM MongoDB.
              <br />
              <br />
              - Utilisation API Stripe / Paypal / Google auth/ Mailjet / IPinfo.
              <br />
              - Référencement naturel et optimisation des pages
              <br />
              - Création du cart et checkout (Stripe).
              <br />
              <br />
              ℹ️ Mise en place de l'hébergement Dockeriser sur OVH (VPS) +
              MongoDb
              <br />
              <br />
              📢 Création et administration des publicités Méta/Google/Pinterest
              ADS avec tunnel de vente optimisé pour la vente de produits +
              optimisation SEO a hauteur de 6000 sessions par mois.
              <br />
              <br />
              <b>Compétences :</b> Node.js · Google Auth · Intégration de PayPal
              · Mongoose ODM · Nuxt.js · API REST · Embedded JavaScript (EJS) ·
              GitHub · SEO · Sendcloud · MailJet · Stripe
            </p>

            <br />
            <br />
            <br />
            <br />

            <p>
              <b>
                Développeur web - ERP interne NuxtJs Développeur web - ERP
                interne NuxtJs
              </b>
              <br />
              oct. 2022 - déc. 2023 · 1 an 3 moisDu oct. 2022 au déc. 2023 · 1
              an 3 mois
              <br />
              <br />
              Réalisation du site d'administration interne
              <br />
              <br />
              ℹ️ Utilisation du Framework Front-end (SSR) NuxtJs couplé avec le
              Backend de l'API Rest en NodeJs
              <br />
              <br />
              - Interface graphique construite avec Vuetify (Material).
              <br />
              - Authentification avec token JWT.
              <br />
              - Routage Post/Put/Get/Delete.
              <br />
              - Drag an drop.
              <br />
              - Automatisation d'envoi de mails avec l'API mailjet (panier
              abandonné, retour de stock etc).
              <br />
              - Gestion de produit avec suggestions de prix.
              <br />
              <br />
              <b>Compétences :</b> Node.js · Nuxt.js · API REST · GitHub ·
              Docker · Nginx · Vuejs
            </p>
          </div>
          <div class="col-md-5 jc-center">
            <div class="row">
              <div class="col-md-12 jc-center">
                <span
                  class="iconify"
                  data-icon="logos:nodejs"
                  style={{ fontSize: "7.8rem" }}
                ></span>
              </div>
              <div class="col-md-12 jc-center">
                <span
                  class="iconify"
                  data-icon="logos:mongodb"
                  style={{ fontSize: "4.9rem" }}
                ></span>
              </div>
              <div class="col-md-12 jc-center">
                <span
                  class="iconify"
                  data-icon="uim:vuejs"
                  style={{ fontSize: "7rem" }}
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Prettiersun;
